import type { SVGProps } from "react"

/**
 * The two flags the language picker shows, from `country-flag-icons` (3x2).
 *
 * Inlined rather than imported: that package defines every flag in one 335 KB
 * module, and even its per-flag entry points re-export from it, so two icons
 * pulled the whole set into the module graph.
 */

export function GB(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...props}>
      <g fill="#FFF">
        <path d="M0 0h513v341.3H0V0z" />
        <path d="M311.7 230 513 341.3v-31.5L369.3 230h-57.6zM200.3 111.3 0 0v31.5l143.7 79.8h56.6z" />
      </g>
      <path
        d="M393.8 230 513 295.7V230H393.8zm-82.1 0L513 341.3v-31.5L369.3 230h-57.6zm146.9 111.3-147-81.7v81.7h147zM90.3 230 0 280.2V230h90.3zm110 14.2v97.2H25.5l174.8-97.2zm-82.1-132.9L0 45.6v65.7h118.2zm82.1 0L0 0v31.5l143.7 79.8h56.6zM53.4 0l147 81.7V0h-147zm368.3 111.3L513 61.1v50.2h-91.3zm-110-14.2V0h174.9L311.7 97.1z"
        fill="#0052B4"
      />
      <g fill="#D80027">
        <path d="M288 0h-64v138.7H0v64h224v138.7h64V202.7h224v-64H288V0z" />
        <path d="M311.7 230 513 341.3v-31.5L369.3 230h-57.6zm-168 0L0 309.9v31.5L200.3 230h-56.6zm56.6-118.7L0 0v31.5l143.7 79.8h56.6zm168 0L513 31.5V0L311.7 111.3h56.6z" />
      </g>
    </svg>
  )
}

export function FR(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...props}>
      <path fill="#FFF" d="M0 0h513v342H0z" />
      <path fill="#00318A" d="M0 0h171v342H0z" />
      <path fill="#D80027" d="M342 0h171v342H342z" />
    </svg>
  )
}
